import { adaptBoolean, adaptHtml, adaptMedia, adaptSelector } from 'adapters/base';

export const adaptGalleryGrid = (component, language) => {
  try {
    return {
      id: component.path,
      controlId: component.controlId,
      type: 'galleryGrid',
      fields: {
        fullWidth: adaptBoolean(component.contentFields[0], 'full_width', language),
        marginBottom: adaptSelector(component.contentFields[0], 'margin_bottom', language, 'margin__bottom__160'),
        maxElementsRow: adaptSelector(component.contentFields[0], 'max_elements_row', language, '4'),
        images: __adaptImages(component.contentFields[0], 'gallery', language),
      },
    };
  } catch (e) {
    console.error('Error adapting GalleryGrid component', e);
    return null;
  }
};

const __adaptImages = (contentFields, path, language) => {
  if (!contentFields) return [];

  const contentField = contentFields.find((contentField) => contentField.path === path);

  if (!contentField?.contentFields) return [];

  return contentField.contentFields.map((field) => {
    return {
      galleryImage: adaptMedia(field, 'gallery_image', language, ''),
      galleryCaption: adaptHtml(field, 'gallery_caption', language, ''),
    };
  });
};
